import { makeStyles, Theme, createStyles, Input } from "@material-ui/core";
import React from "react";
import { useState, useEffect, useCallback } from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    colorPicker: {
      width: "3.5em",
      height: "1.25em",
      padding: "0px",
      border: "1px solid darkgray",
      borderRadius: "2px",
      "&:hover": {
        border: "1px solid black"
      }
    }
  })
);

interface ColorPickerProps {
  value: string;
  onSubmit(value): void;
}

export const ColorPicker = (props: ColorPickerProps) => {
  const {value, onSubmit} = props;

  const classes = useStyles();
  const [color, setColor] = useState("#000000");

  useEffect(() => {
    setColor(value);
  }, [value]);

  const onChange = useCallback((event) => {
    setColor(event.target.value);
  }, []);

  return (
    <Input
      value={color}
      onChange={onChange}
      onBlur={() => {
        onSubmit(color);
      }}
      disableUnderline={true}
      classes={{
        input: classes.colorPicker
      }}
      type="color"
    />
  );
};